import { PayablesService_payablesServiceGetQuery } from '@festina/moneyout-general-types/moneyout/hooks/PayablesService_payablesServiceGetQuery'

export const useFetchPayablesNoSuspense =
  PayablesService_payablesServiceGetQuery.useQuery
